<!--檢查預約資料-->
<div class="page-container reserve-confirm-content">
  <!--title 標題-->
  <div class="page-title-block">
    <h2 class="page-title">{{ 'appointment-confirm.title' | translate }}</h2>
    <div class="page-subtitle-block">
      <img width="26" height="26" ngSrc="assets/img/i-clock-user.svg" alt="clock-user" />
      <p>{{ 'appointment-confirm.hint' | translate }}</p>
    </div>
  </div>

  <!--選擇方案-->
  <div class="card-content register-card-content">
    <h3 class="register-card-title">
      {{ 'appointment-confirm.selected-package' | translate }} ：{{
      selectedPackage
      }}
    </h3>
    @if (isPersonalReserve) {
      <!-- 個人預約 - 應付金額 -->
      <div class="confirm-body">
        <div class="confirm-body-item">
          <p class="confirm-body-item-title">
            {{ 'appointment-confirm.payment-amount' | translate }}
          </p>
          <p><label>$</label>{{ paymentAmount | numberComma }}</p>
        </div>

        <div class="confirm-body-item">
          <p class="confirm-body-item-title">
            {{ 'appointment-confirm.estimated-exam-time' | translate }}
          </p>
          <p>{{ dayType }}{{ 'appointment-confirm.exam' | translate }}</p>
        </div>
      </div>
    } @else {
      <!-- 企業預約 - 總金額 -->
       <!-- 當應付金額大於0時,才顯示總金額 -->
      <div class="confirm-body">
        @if (businessSelfAmt > 0) {
          <div class="confirm-body-item">
            <p class="confirm-body-item-title">
              {{ 'my-reservation.total-amount' | translate }}
            </p>
            <p>
              <label>$</label>
              {{ businessBillAmt | numberComma }}
            </p>
          </div>
        }

        <!-- 當補助金大於應付金額時,不顯示補助金額 -->
            @if (hasSponsorAmount && businessBillAmt > businessSponsorAmt) {
            <!-- 企業補助金額 -->
              <div class="confirm-body-item">
                <p class="confirm-body-item-title">
                  {{ 'my-reservation.company-sponsorAmt' | translate }}
                </p>
                <p>
                  <label>$-</label>{{ businessSponsorAmt | numberComma }}
                </p>
              </div>
          }
            <div class="confirm-body-item">
              <p class="confirm-body-item-title">
                {{ 'appointment-confirm.payment-amount' | translate }}
              </p>
              <p><label>$</label>
                @if (businessSelfAmt < 0) {
                  0
                } @else {
                  {{ businessSelfAmt | numberComma }}
                }
              </p>
            </div>

            <div class="confirm-body-item">
              <p class="confirm-body-item-title">
                {{ 'appointment-confirm.estimated-exam-time' | translate }}
              </p>
              <p>{{ dayType }}{{ 'appointment-confirm.exam' | translate }}</p>
            </div>
          </div>
        }
    @if (showFullExamInfos) {
    <!--方案檢項-->
    <div class="confirm-body plan-item">
      <!-- 已選方案-->
      <div class="confirm-body-item confirm-plan-item">
        <p class="confirm-plan-item-title">
          {{ selectedPackage }}{{ 'appointment-confirm.package' | translate }}
        </p>
        <p><label>$</label>{{ paymentAmount | numberComma }}</p>
      </div>
      @if (isPersonalReserve) {
      @for (
      examTypeMap of examInfoListByType.entries();
      track examTypeMap[0]
      ) {
      <div class="reserve-confirm-cart-item">
        <h3>{{ examTypeMap[0] }}</h3>
        @for (deptMap of examTypeMap[1]; track deptMap[0]) {
        <div class="reserve-confirm-cart-item-title" (click)="
                    toggleDeptOpenStateByExamType(examTypeMap[0], deptMap[0])
                  ">
          <h4>{{ deptMap[0] }}</h4>
          <img width="24" height="24" alt="" [ngSrc]="
                      getDeptOpenStateByExamType(examTypeMap[0], deptMap[0])
                        ? 'assets/img/i-arrow-up.svg'
                        : 'assets/img/i-arrow-down.svg'
                    " />
        </div>
        @if (getDeptOpenStateByExamType(examTypeMap[0], deptMap[0])) {
        <div class="reserve-confirm-cart-item-block">
          @for (examInfo of deptMap[1]; track examInfo.examItem) {
          <div class="reserve-confirm-cart-checked-item">
            <div>
              <button mat-icon-button type="button" class="btn-icon btn-info" (click)="showExamDialog(examInfo)">
                <img width="14" height="14" ngSrc="assets/img/i-info.svg" alt="" />
              </button>
              <p>{{ examInfo.examName }}</p>
            </div>
          </div>
          }
        </div>
        }
        }
      </div>
      }
      } @else {
      <!--企業檢項-->
      <div class="reserve-confirm-cart-item">
        @if (businessSelectedPackage) {
          @for (dept of businessSelectedPackage.deptList; track dept.deptName) {
            @if ((dept.examItemList?.length ?? 0) > 0) {
              <div class="reserve-confirm-cart-item-title" (click)="
                isDeptNameOpen.set(dept.deptName, !isDeptNameOpen.get(dept.deptName))
              ">
                <h4>{{ removeDeptNameEnglish(dept.deptName) }}</h4>
                <button mat-button class="btn-icon">
                  <img width="24" height="24" alt="" [ngSrc]="
                    isDeptNameOpen.get(dept.deptName)
                      ? 'assets/img/i-arrow-up.svg'
                      : 'assets/img/i-arrow-down.svg'
                  " />
                </button>
              </div>
              @if (isDeptNameOpen.get(dept.deptName)) {
                <div class="reserve-confirm-cart-item-block">
                  @for (examItem of dept.examItemList; track examItem.examItem) {
                    <div class="reserve-confirm-cart-checked-item">
                      <div>
                        <button mat-icon-button type="button" class="btn-icon btn-info"
                          (click)="showExamDialog(examItem)">
                          <img width="14" height="14" ngSrc="assets/img/i-info.svg" alt="" />
                        </button>
                        <p>{{ examItem.examName }}</p>
                      </div>
                    </div>
                  }
                </div>
              }
            }
          }
        }
      </div>
      }
    </div>

    <!--加購檢項-->
    @if (addExamItemList.length > 0) {
    <div class="confirm-body">
      <div class="confirm-body-item confirm-plan-item">
        <p class="confirm-plan-item-title">
          {{ 'appointment-confirm.add-exam-item' | translate }}
        </p>
        <!-- <p><label>$</label>{{ addExamItemPrice | numberComma }}</p> -->
      </div>
      <div class="reserve-confirm-cart-item add-item">
        @for (addExamInfo of addExamItemList; track addExamInfo.examItem) {
        <div class="reserve-confirm-cart-checked-item">
          <div>
            <button mat-icon-button type="button" class="btn-icon btn-info" (click)="showExamDialog(addExamInfo)">
              <img width="14" height="14" ngSrc="assets/img/i-info.svg" alt="" />
            </button>
            <p>{{ addExamInfo.examName }}</p>
          </div>
          <div>
            <p class="reserve-confirm-add-cart-item">
              <label>$</label> {{ addExamInfo.price | numberComma }}
            </p>
          </div>
        </div>
        }
      </div>
    </div>
    }
    }

    <button mat-button class="btn-text-primary btn-size-m" (click)="toggleShowFullExamInfos()">
      {{ 'appointment-confirm.show-full-exam' | translate }}
      <img [ngSrc]="
          showFullExamInfos ? 'assets/img/i-minus.svg' : 'assets/img/i-add.svg'
        " width="12" height="12" alt="toggle icon" />
    </button>
  </div>

  <!--預約資訊-->
  <div class="card-content register-card-content">
    <h3 class="register-card-title">
      {{ 'appointment-confirm.reserve-info' | translate }}
    </h3>

    <!--預約資料-->
    <div class="confirm-header">
      <h4 class="confirm-header-title">
        {{ 'appointment-confirm.reserve-data' | translate }}
      </h4>
      <button mat-button class="btn-icon" (click)="previous()">
        <img width="16" height="16" ngSrc="/assets/img/i-pencil-g.svg" alt="" />
      </button>
    </div>
    <div class="confirm-body">
      <div class="confirm-body-item">
        <p class="confirm-body-item-title">
          {{ 'appointment-confirm.health-check' | translate }}
        </p>
        <p>{{ healthCheckTime }}</p>
      </div>
      @if(isShowNutrition){
      <div class="confirm-body-item">
        <p class="confirm-body-item-title">
          {{ 'appointment-confirm.nutrition-consultation' | translate }}
        </p>
        <p>{{ nutritionConsultationTime }}</p>
      </div>
      }
      @for (imageItemName of imageItemNames; track $index) {
      <div class="confirm-body-item">
        <p class="confirm-body-item-title">{{ imageItemName }}</p>
        <p>
          {{ 'appointment-confirm.someone-call-to-confirm-time' | translate }}
        </p>
      </div>
      }
      <div class="confirm-body-item">
        <p class="confirm-body-item-title">
          {{ 'appointment-confirm.exam-center' | translate }}
        </p>
        <p [innerHTML]="orgName"></p>
      </div>
    </div>

    <!--檢查相關資料與報告-->
    <div class="confirm-header">
      <h4 class="confirm-header-title">
        {{ 'appointment-confirm.exam-data-and-report' | translate }}
      </h4>
      <button mat-button class="btn-icon" (click)="openModifyExamReportDialog()">
        <img width="16" height="16" ngSrc="/assets/img/i-pencil-g.svg" alt="" />
      </button>
    </div>
    <div class="confirm-body">
      <div class="confirm-body-item">
        <p class="confirm-body-item-title">
          {{ 'appointment-confirm.pre-exam-address' | translate }}
        </p>
        @if ( bookingInfo?.noticeSendType === '2' ) { 
          <p>{{ 'appointment-info.pick-up-by-agent' | translate }}</p>}
        @else if (bookingInfo?.noticeSendType === '3') { 
          <p>{{ 'appointment-info.not-need-to-send' | translate }}</p> }
        @else { <p>{{ preExamAddress }}</p> }
      </div>

      <!--不須寄送/承辦領取 顯示聯絡地址-->
        @if (
        bookingInfo?.noticeSendType === '2'|| bookingInfo?.noticeSendType === '3'
        ) {
          <div class="confirm-body-item">
          <p class="confirm-body-item-title">
          {{ 'appointment-complete.contact-address' | translate }}
          </p>
          <p>{{ preExamAddress }}</p>
          </div>
        }
        
      
      <!-- 顯示檢查報告領取方式 -->
      <div class="confirm-body-item">
        <p class="confirm-body-item-title">
          {{ 'appointment-confirm.exam-report-delivery' | translate }}
        </p>
        @if (bookingInfo?.reportSendType === '2') {
          <p>{{ 'appointment-info.pick-up-by-agent' | translate }}</p>
        }@else if (bookingInfo?.reportSendType === '3' || bookingInfo?.reportSendType === '99') {
          <p>{{ 'appointment-info.not-need-to-send' | translate }}</p>
        } @else {
        <p [innerHTML]="examReportAddress"></p>
        }
      </div>

      <!-- 顯示收件人資料 -->
      @if (
        bookingInfo?.reportSendType !== '2' && bookingInfo?.reportSendType !== '3'&& bookingInfo?.reportSendType !== '99'
        ) {
        <div class="confirm-body-item">
          <p class="confirm-body-item-title">
            {{ 'appointment-confirm.recipient' | translate }}
          </p>
          <p>{{ recipient }}
              @if(isShowRecipientCell){
                <span class='doc-divider'>・</span>
                {{ recipientCell }}
                }
          </p>
        </div>
         }
      
      <div class="confirm-body-item">
        <p class="confirm-body-item-title">
          {{ 'appointment-confirm.exam-language' | translate }}
        </p>
        <p>{{ examReportLanguage }}
          @if (
            this.bookingInfo?.language === API_PARAMS.EXAM_REPORT_LANGUAGE.JAPANESE.code
            ) {
              ({{
              'appointment-info.addition-translate-fee' | translate
              }})
            }
        </p>
      </div>
    </div>

    <!--健檢服-->
    <div class="confirm-header">
      <h4 class="confirm-header-title">
        {{ 'appointment-confirm.exam-clothes' | translate }}
      </h4>
      <button mat-button class="btn-icon" (click)="openModifyExamClothesDialog()">
        <img width="16" height="16" ngSrc="/assets/img/i-pencil-g.svg" alt="" />
      </button>
    </div>
    <div class="confirm-body">
      <div class="confirm-body-item">
        <p class="confirm-body-item-title">
          {{ 'appointment-confirm.size' | translate }}
        </p>
        <p>{{ examClothesSize }}</p>
      </div>
    </div>

    <!--餐食-->
    <div class="confirm-header">
      <h4 class="confirm-header-title">
        {{ 'appointment-confirm.diet' | translate }}
      </h4>
      <button mat-button class="btn-icon" (click)="openModifyDietDialog()">
        <img width="16" height="16" ngSrc="/assets/img/i-pencil-g.svg" alt="" />
      </button>
    </div>
    <!-- <div class="input-block input-warn-msg">
      <img width="16" height="16" ngSrc="/assets/img/i-warn-outline.svg" alt="" />
      <span>{{ 'appointment-confirm.diet-hint' | translate }}</span>
    </div> -->
    <div class="confirm-body">
      <div class="confirm-body-item">
        <p class="confirm-body-item-title">
          {{ 'appointment-confirm.breakfast' | translate }}
        </p>
        <p>{{ breakfast }}</p>
      </div>
      @if (lunches.length > 0) {
        <div class="confirm-body-item">
          <p class="confirm-body-item-title">
            {{ 'appointment-confirm.lunch' | translate }}
          </p>
          <p>{{ lunch }}</p>
        </div>
      }
    </div>
  </div>

  <!--基本資料-->
  <div class="card-content register-card-content">
    <h3 class="register-card-title">
      {{ 'appointment-confirm.basic-info' | translate }}
    </h3>
    <div class="confirm-body">
      <div class="confirm-body-item">
        <p class="confirm-body-item-title">
          {{ 'appointment-confirm.name' | translate }}
        </p>
        <p>{{ name }}</p>
      </div>
      <div class="confirm-body-item">
        <p class="confirm-body-item-title">
          {{ 'appointment-confirm.id-number' | translate }}
        </p>
        <p>{{ idNumber }}</p>
      </div>
      <div class="confirm-body-item">
        <p class="confirm-body-item-title">
          {{ 'appointment-confirm.birthday' | translate }}
        </p>
        <p>{{ birthday }}</p>
      </div>
    </div>
  </div>

  <!--頁面：固定按鈕區塊-->
  <div class="page-btn-block">
    <button mat-button class="btn-outline-primary btn-size-l" type="button" (click)="previous()">
      {{ 'common.button.previous' | translate }}
    </button>
    <button mat-button class="btn-fill-primary btn-size-l" type="button" (click)="confirm()" [disabled]="isAppointmentSent">
      {{ 'appointment-confirm.confirm' | translate }}
    </button>
  </div>
</div>